import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment-timezone';

@Component({
	selector: 'spaq-conditions-acceptor',
	template: `
		<spaq-markdown [text]="text"> </spaq-markdown>

		<spaq-button id="accept-conditions" testId="accept-conditions" *ngIf="!acceptedAt && showCheckbox" (buttonClick)="onButtonClick()" [primary]="true">
			{{ label }}
		</spaq-button>

		<div *ngIf="acceptedAt">
			Vous avez accepté les conditions le: <u>{{ acceptanceDate }}</u>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConditionsAcceptorComponent {
	get acceptanceDate() {
		return moment(this.acceptedAt).format('LLLL');
	}

	@Output() accept = new EventEmitter();
	@Input() acceptedAt = null;
	@Input() label = 'Accepter les conditions';
	@Input() text = '';
	@Input() showCheckbox = false;

	constructor() {}
	onButtonClick() {
		this.accept.emit();
	}
}
